module.exports = __webpack_public_path__ + "static/img/buyongpa.f0d4d86f.png";